import RSlider from "./RSlider.js";
import RSliderItems  from"./RSliderItems.js";
import RSliderArrowL from "./RSliderArrowL.js";
import RSliderArrowR from "./RSliderArrowR.js";
import RSliderPagination from "./RSliderPagination.js";

module.exports = {
	RSlider,
	RSliderItems,
	RSliderArrowL,
	RSliderArrowR,
	RSliderPagination
};




// WEBPACK FOOTER //
// ./src/index.js